<template>
  <div class="weekly-goods" :class="{boxSty: !noStyle}" @click="goIndexDetail(item)">
    <a>
      <p class="weekly-goods-icon-1" v-if="item.favorites_type === 0">
        <span>
          <img src="static\img\index\img\icon_6(1).png" alt=""
            @click.stop="handleCollect(item, 1, index, ...collectParams)" />
        </span>
      </p>
      <!--收藏后变颜色-->
      <p class="weekly-goods-icon-2" v-if="item.favorites_type === 1">
        <span>
          <img src="static\img\index\img\icon_7.png" alt=""
            @click.stop="handleCollect(item, 2, index, ...collectParams)" />
        </span>
      </p>
      <!--收藏后变颜色-->
      <div class="weekly-goods-img">
        <img class="move-img" :src="item.goods_img ||
          'static/img/goodsList/goods_default_img.jpg'
          " :onerror="defaultGoodsImg" alt="图片破损" />
        <div class="frame-img" v-if="item.frame !== ''">
          <img :src="item.frame" alt="" />
        </div>
      </div>

      <template v-if="showType == 'sale'">
        <p class="weekly-goods-intro">{{ item.goods_name }}</p>
        <p class="weekly-goods-bieming" style="margin-top: 10px;" v-if="item.bieming != '无码'">
          <span class="bieming-bor">{{ showMa(item.bieming) }}</span>
          <!-- 禁止挂网标签：当 goods_tags 中包含"禁止挂网"时展示为红色 -->
          <span
            v-if="showForbidNet(item.goods_tags)"
            class="forbid-net-tag"
          >
            禁止挂网
          </span>
        </p>
        <p class="weekly-goods-spec" style="margin-top: 10px;">规格：{{ item.specification }}</p>
        <p class="weekly-goods-loginPrice" style="margin-top: 8px;">
          <span class="weekly-price" v-if="item[priceProp] !== ''">
            ￥{{ item[priceProp] }}/{{ item.unit }}
          </span>
          <span class="weekly-price" v-else-if="item.selling_price !== ''">
            ￥{{ item.selling_price }}/{{ item.unit }}
          </span>
          <span class="weekly-old-price" v-if="item[priceProp] !== item.original_price">
            <s>￥{{ item.original_price }}</s>
          </span>
        </p>
      </template>
      <template v-else>
        <p class="weekly-goods-loginPrice">
          <span class="weekly-price" v-if="item[priceProp] !== ''">
            ￥{{ item[priceProp] }}/{{ item.unit }}
          </span>
          <span class="weekly-price" v-else-if="item.selling_price !== ''">
            ￥{{ item.selling_price }}/{{ item.unit }}
          </span>
          <span class="weekly-old-price" v-if="item[priceProp] !== item.original_price">
            <s>￥{{ item.original_price }}</s>
          </span>
        </p>
        <p class="weekly-goods-intro">{{ item.goods_name }}</p>
        <!--  <p class="weekly-goods-spec">{{ item.manufacturer_name }}</p>
        <p class="weekly-goods-spec">效期：<span style="color: red;">{{ item.expiration_date }}</span></p>-->
        <p class="weekly-goods-spec">规格：{{ item.specification }}</p>
        <!-- <p class="weekly-goods-noLogin" v-show="!userInfo.username">价格登录可见</p>-->
        <div class="goods-bottom-icon">
          <p v-for="(label, index) in getLabels(item.lables)" :class="['pro-more-' + index + 1]" :key="index">
            {{ goodsLabelSet[label] }}
          </p>
        </div>
      </template>
    </a>
  </div>
</template>

<script>
import { showForbidNet } from '@/utils/goods'
export default {
  name: "HomeShop",
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    goIndexDetail: {
      type: Function,
    },
    defaultGoodsImg: {
      type: String,
    },
    goodsLabelSet: {
      type: Object,
      default: () => ({})
    },
    showType: {
      type: String, // sale - 特价排版
      default: "sale"
    },
    handleCollect: {
      typeof: Function,
      default: () => () => {}
    },
    collectParams: {
      type: Array,
      default: () => []
    },
    priceProp: { // 价格的字段
      type: String,
      default: "selling_price"
    },
    noStyle: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    getLabels(labels) {
      if (labels) {
        return labels.split(",").length > 4
          ? labels.split(",").slice(3)
          : labels.split(",");
      } else {
        return ['0']
      }
    },
    showMa(info) {
      if(info == '无码') {
        return '';
      } else if(info == '仅中包装有码') {
        return '仅中包装有追溯码';
      } else {
        return '追溯码';
      }
    },
    // 使用工具函数 showForbidNet
    showForbidNet,
  },
}
</script>

<style lang="less" scoped>
.weekly-goods {
  position: relative;
  cursor: pointer;
  // background-color: pink;
}
.boxSty {
  width: 230px;
  // width: 19%;
  // height: 350px;
  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #f0f0f0;
  box-shadow: 0px 4px 8px 0px rgba(179, 179, 179, 0.2);
  margin-bottom: 15px;
  // margin-right: 12px;
  padding: 20px 17px;
}

.weekly-goods-icon {
  width: 50px;
  height: 50px;
  background: linear-gradient(180deg, #ff4367 0%, #fe5789 100%);
  box-shadow: 0px 2px 6px 0px rgba(184, 18, 50, 0.2);
  font-size: 16px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #ffffff;
  line-height: 50px;
  text-align: center;
  border-radius: 50%;
  position: absolute;
  top: 0;
  left: 10px;
  z-index: 2;
}

.weekly-goods-icon-1 {
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: none;
  z-index: 2;

  span {
    line-height: 33px;
  }
}

.weekly-goods:hover .weekly-goods-icon-1 {
  display: block;
}

.weekly-goods-icon-2 {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 30px;
  height: 30px;
  display: none;
  z-index: 10;

  span {
    line-height: 33px;
  }
}

.weekly-goods:hover .weekly-goods-icon-2 {
  display: block;
}

.weekly-goods-img {
  width: 190px;
  // --height: 140px;
  height: 140px;
  margin: auto;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;

  img {
    width: 180px;
    --height: 140px;
  }

  .move-img:hover {
    /* transform: translateY(-5px);
        transition-duration: 1s;*/
  }

  .frame-img {
    position: absolute;
    top: 0;
    left: 0;
  }

}

.weekly-goods-intro {
  font-size: 18px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 600;
  color: #111;
  padding: 0 3px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.weekly-goods-spec {
  font-size: 16px;
  color: #333;
  line-height: 17px;
  text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
  text-align: left;
  padding-top: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 3px;
}

.weekly-goods-bieming {
  font-size: 16px;
  color: #333;
  line-height: 20px;
  text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
  text-align: left;
  padding-top: 5px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding-left: 3px;
}

.bieming-bor {
  color: rgb(0, 0, 255);
  font-size: 15px;
  border: 1px solid;
  line-height: 1em;
  margin-right: 5px;
  padding: 1px 2px;
  border-radius: 5px;
  font-weight: bold;
}

.forbid-net-tag {
  display: inline-block;
  margin-left: 5px;
  padding: 1px 6px;
  font-size: 12px;
  color: #fff;
  background: #ff4d4f;
  border-radius: 2px;
  line-height: 18px;
}

.weekly-goods-noLogin {
  font-size: 20px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 600;
  color: #fa0000;
  padding-top: 8px;
}

.weekly-goods-loginPrice {
  padding-top: 8px;

  .weekly-price {
    font-size: 20px;
    font-family: PingFangHK-Medium, PingFangHK;
    font-weight: 600;
    color: #fa0000;
    line-height: 20px;
  }

  .weekly-old-price {
    font-size: 18px;
    color: #666;
    text-shadow: 0px 2px 6px rgba(220,220,220,0.3);
    line-height: 17px;
    padding-left: 10px;
  }
}
.goods-bottom-icon {
  display: flex;
  padding-left: 3px;
  margin-top: 8px;

  p {
    font-size: 12px;
    padding: 1px 7px;
    // color: #FA0000;
    // background: #fff;
    // border: 1px solid #FA0000;
    // box-shadow: 0px 2px 6px 0px rgba(220, 220, 220, 0.3), 0px 1px 2px 0px rgba(22, 124, 58, 0.1);
    color: #fff;
    background: #FF515A;
    box-shadow: 0px 2px 6px 0px rgba(220,220,220,0.3), 0px 1px 2px 0px rgba(181,2,14,0.1);
    border-radius: 3px;
    margin-right: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HomeComponents/HomeShop.vue